import React from "react";

type Props = {
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};

const FamilyTreeNodeItem: React.FC<Props> = (props) => {
  return (
    <div
      style={{
        top: "20px",
        right: "40px"
      }}
      className="absolute p-2 flex items-center text-white bg-or_purple-500 rounded-full cursor-pointer"
      onClick={props.onClick}
    >
      {props.children}
    </div>
  );
};

export default FamilyTreeNodeItem;
